import React from 'react';
import { Link } from '@zola/zola-ui';
import OtherThingsToReview from './OtherThingsToReview';
import './TipsModals.less';

function TipBack() {
  return (
    <div className="etiquette-tip-modal">
      <div className="tip-content-container">
        <div className="modal-body">
          <h3> 5 Tips For Choosing Great Photos</h3>
          <div className="section">
            <p className="desc">
              If you’ve sprung for engagement photos, or are just using a photo from your phone’s
              camera roll, make sure you choose a photograph that best compliments you and your
              design. Here are some tips to help you pick your best pic.
            </p>
          </div>
          <div className="section">
            <p className="head">Tip 1: Keep It Simple</p>
            <p className="desc">
              Go for a simple, uncluttered composition—just the two of you, looking lovely. Make
              sure the central element of the photo is in focus, and the general mood matches your
              invitation style.
            </p>
          </div>
          <div className="section">
            <p className="head">Tip 2: Harmonize Hues</p>
            <p className="desc">
              Make sure your photo blends, rather than clashes, with the colors of your invitation.
              Avoid busy patterns if your invitation has a lot going on, or make your photo the star
              if you’ve chosen a simpler card.
            </p>
          </div>
          <div className="section">
            <p className="head">Tip 3: Bring On B&W</p>
            <p className="desc">
              Black and white photography has a certain elegance that can elevate any pose, not to
              mention hide imperfections. A black and white photo will set the tone for a timeless,
              classic affair.
            </p>
          </div>
          <div className="section">
            <p className="head">Tip 4: Come In Close</p>
            <p className="desc">
              It should be clear that you two are the central characters here, so make sure your
              faces or bodies are framed nicely. Don’t make your guests hunt to find you in the
              scene.
            </p>
          </div>
          <div className="section">
            <p className="head">Tip 5: Have Fun With It</p>
            <p className="desc">
              Put your joy front and forward. Especially if your invitation design leans whimsical,
              don’t be afraid to choose a fun, goofy, or more unconventional photo.
            </p>
            <p className="desc">
              Read even more about how to choose photographs for your invitation suite on our{' '}
              <Link
                inline
                href="/blog/wedding-planning/how-to-choose-engagement-photos-for-your-paper-suite/"
              >
                blog
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
      <OtherThingsToReview />
    </div>
  );
}

export default TipBack;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/TipsModals/TipBack.jsx